import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { MeusContatosPage } from './meus-contatos.page';

const routes: Routes = [
  {
    path: '',
    component: MeusContatosPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MeusContatosPageRoutingModule {}
